import { config } from './configFromWindow';

const debugEnvironments = ['localdev', 'development', 'pr', 'staging'];

export const getIsDebugEnvironment = () => {
    if (process.env.NODE_ENV !== 'production') {
        return true;
    }

    return debugEnvironments.includes(config?.deployEnvironment);
};
